import { Component, OnInit } from "@angular/core";
import { NgForm } from "@angular/forms";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { AuthService } from "../../services/auth.service";
import * as JsonToXML from "js2xmlparser";

import { Storage } from "../../storage/storage";
import { SafeUrlPipe } from "../../pipes/safe-url.pipe";
import { CatalogService } from "../../services/catalog.service";

@Component({
  selector: "app-cart",
  templateUrl: "./cart.component.html",
  styleUrls: ["./cart.component.css"],
  providers: [SafeUrlPipe, CatalogService],
})
export class CartComponent implements OnInit {
  catalogId: any;
  productCart: any[];
  pdtCount: Number;
  cartPrice: Number;
  hook_url_SAP: string;
  submitted = false; //form not submited : default
  data: any;
  xmlData: any;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private ctlgSrv: CatalogService,
    private storage: Storage,
    private router: Router
  ) {
    this.pdtCount = 0;
    this.cartPrice = 0;
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.catalogId = params["catalogId"];
      let toto = this.storage.hook_url.replace(/&amp;/g, "&");
      console.log("---> toto", toto);
      this.hook_url_SAP = toto;
      this.pdtCount = this.storage.cart.length;
      this.productCart = this.storage.cart;
      this.refreshCartData();
    });
    window.scrollTo(0, 0);
  }

  goToCatalog() {
    this.router.navigate(["catalog/", this.catalogId]);
  }

  refreshCartData() {
    this.productCart = this.storage.cart;
    this.pdtCount = this.storage.cart.length;
    this.cartPrice = this.storage.cart.reduce((prev, item1) => {
      return Math.round((prev + item1.price * item1.quantity) * 100) / 100;
    }, 0);
  }

  removeItem(pdt) {
    let index = this.storage.cart.findIndex(
      (item) => item.sup_part_num == pdt.sup_part_num
    );
    this.storage.cart.splice(index, 1);
    this.refreshCartData();
  }

  increment(pdt) {
    let index = this.storage.cart.findIndex(
      (item) => item.sup_part_num == pdt.sup_part_num
    );
    this.storage.cart[index].quantity += 1;
    this.refreshCartData();
  }

  decrement(pdt) {
    let index = this.storage.cart.findIndex(
      (item) => item.sup_part_num == pdt.sup_part_num
    );
    if (this.storage.cart[index].quantity === 1) {
      //
    } else {
      this.storage.cart[index].quantity -= 1;
    }
    this.refreshCartData();
  }

  sendCartSap() {
    console.log("-----> send cart");

    // let xml = "fake data";
    let cartJSON = {
      cXML: {
        "@": {
          version: "1.1",
          "xml:lang": "en-US",
          payloadID: "200303450803006749@b2b.euro.com",
          timestamp: new Date(),
        },
        Header: {
          From: {
            Credential: {
              "@": {
                domain: "DUNS",
              },
              Identity: {
                "#": "capgemini",
              },
            },
          },
          To: {
            Credential: {
              "@": {
                domain: "DUNS",
              },
              Identity: {
                "#": "capgemini",
              },
            },
          },
          Sender: {
            Credential: {
              "@": {
                domain: "DUNS",
              },
              Identity: {
                "#": "capgemini",
              },
            },
            UserAgent: {
              "#": "Oracle iProcurement",
            },
          },
        },
        Message: {
          PunchOutOrderMessage: {
            BuyerCookie: {
              "#": `${this.storage.buyerCookie}`,
            },
            PunchOutOrderMessageHeader: {
              "@": {
                operationAllowed: "edit",
              },
              Total: {
                Money: {
                  "@": {
                    currency: "EUR",
                  },
                  "#": this.cartPrice,
                },
              },
            },
            ItemIn: [],
          },
        },
      },
    };

    let cartArrayXMLReady = this.productCart.map((pdtCart) => {
      console.log("--> cart", pdtCart);
      return {
        "@": {
          quantity: pdtCart.quantity,
        },
        ItemID: {
          SupplierPartID: {
            "#": pdtCart.sup_part_num.slice(0, -3),
          },
          SupplierPartAuxiliaryID: {
            "#": pdtCart.sup_part_aux_num.slice(0, -3),
          },
        },
        ItemDetail: {
          UnitPrice: {
            Money: {
              "@": {
                currency: pdtCart.currency,
              },
              "#": pdtCart.price,
            },
          },
          Description: {
            "@": {
              "xml:lang": `${pdtCart.language.toLowerCase()}-${pdtCart.language.toUpperCase()}`,
            },
            "#": pdtCart.short_description,
          },
          UnitOfMeasure: {
            "#": pdtCart.uom,
          },
          Classification: {
            "@": {
              domain: "UNSPSC",
            },
            "#": pdtCart.unspsc,
          },
          ManufacturerPartID: {
            "#": pdtCart.mfr_number,
          },
          ManufacturerName: {
            "#": pdtCart.mfr_name,
          },
        },
      };
    });

    cartJSON.cXML.Message.PunchOutOrderMessage.ItemIn = cartArrayXMLReady;

    let xml = JsonToXML.parse("PunchOutOrderMessage", cartJSON, {
      dtd: {
        include: true,
        name: "cXML",
        sysId: "http://xml.cxml.org/schemas/cXML/1.1.010/cXML.dtd",
        // pubId: "http://xml.cxml.org/schemas/cXML/1.2.014/cXML.dtd",
      },
      declaration: {
        include: true,
        encoding: "UTF-8",
        version: "1.0",
      },
    });
    console.log("---> xml", xml);
    this.storage.xmlData = xml;
    this.router.navigate(["cart/oracle/PunchOutOrderMessage"]);
  }

  onSubmit(data: NgForm) {
    this.submitted = true;
    //this.data = JSON.stringify(data, null, 2);
    console.log(data);
  }
}

// http://localhost:4200/oracle/catalog/5902fb7704c176790a7124b2?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImNhcGdlbWluaSIsImlzT3JhY2xlIjp0cnVlLCJob29rX3VybCI6Imh0dHBzOi8vZmllYnNiYXMuY29ycC5jYXBnZW1pbmkuY29tOjQ0NDcvT0FfSFRNTC9PQS5qc3A_T0FGdW5jPUlDWF9DQVRfUFVOQ0hPVVRfQ0FMTEJBQ0smT0FIUD1JQ1hfUE9SX0hPTUVQQUdFX01FTlUmT0FTRj1JQ1hfQ0FUX1BVTkNIT1VUX0NBTExCQUNLJnRyYW5zYWN0aW9uaWQ9MjcwOTM5NTU0Jm9wZXJhdGlvbmtleT05NGJlNmEyNjMzZDJiNWJlIiwiaWF0IjoxNjEwNTM4MzQyfQ.QexB_OFwJrTSRC2TDrBaRAzSwvK1nG8qc-2vSpypHoo&HOOK_URL=https://fiebsbas.corp.capgemini.com:4447/OA_HTML/OA.jsp?OAFunc=ICX_CAT_PUNCHOUT_CALLBACK&OAHP=ICX_POR_HOMEPAGE_MENU&OASF=ICX_CAT_PUNCHOUT_CALLBACK&transactionid=270939554&operationkey=94be6a2633d2b5be

// http://localhost:4200/oracle/catalog/5902fb7704c176790a7124b2?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImNhcGdlbWluaSIsImlzT3JhY2xlIjp0cnVlLCJob29rX3VybCI6Imh0dHBzOi8vZmllYnNiYXMuY29ycC5jYXBnZW1pbmkuY29tOjQ0NDcvT0FfSFRNTC9PQS5qc3A_T0FGdW5jPUlDWF9DQVRfUFVOQ0hPVVRfQ0FMTEJBQ0smT0FIUD1JQ1hfUE9SX0hPTUVQQUdFX01FTlUmT0FTRj1JQ1hfQ0FUX1BVTkNIT1VUX0NBTExCQUNLJnRyYW5zYWN0aW9uaWQ9MjcwOTM5NTU0Jm9wZXJhdGlvbmtleT05NGJlNmEyNjMzZDJiNWJlIiwiaWF0IjoxNjEwNTQ0MzgyfQ.Opnc-dQGxsNRnAHVh1mJ0sViHfYrdBpKRblt5Ke5xZk&HOOK_URL=https%3A%2F%2Ffiebsbas.corp.capgemini.com%3A4447%2FOA_HTML%2FOA.jsp%3FOAFunc%3DICX_CAT_PUNCHOUT_CALLBACK%26OAHP%3DICX_POR_HOMEPAGE_MENU%26OASF%3DICX_CAT_PUNCHOUT_CALLBACK%26transactionid%3D270939554%26operationkey%3D94be6a2633d2b5be

// http://localhost:4200/oracle/catalog/5902fb7704c176790a7124b2?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImNhcGdlbWluaSIsImlzT3JhY2xlIjp0cnVlLCJob29rX3VybCI6Imh0dHBzOi8vZmllYnNiYXMuY29ycC5jYXBnZW1pbmkuY29tOjQ0NDcvT0FfSFRNTC9PQS5qc3A_T0FGdW5jPUlDWF9DQVRfUFVOQ0hPVVRfQ0FMTEJBQ0smT0FIUD1JQ1hfUE9SX0hPTUVQQUdFX01FTlUmT0FTRj1JQ1hfQ0FUX1BVTkNIT1VUX0NBTExCQUNLJnRyYW5zYWN0aW9uaWQ9MjcwOTM5NTU0Jm9wZXJhdGlvbmtleT05NGJlNmEyNjMzZDJiNWJlIiwiaWF0IjoxNjEwNTUwOTIwfQ.P87ISlRazVy7eLsU88sGYHcxrDvZDQ_Z_CLvSpOu61g&buyerCookie=37151610375253935&HOOK_URL=https%3A%2F%2Ffiebsbas.corp.capgemini.com%3A4447%2FOA_HTML%2FOA.jsp%3FOAFunc%3DICX_CAT_PUNCHOUT_CALLBACK%26OAHP%3DICX_POR_HOMEPAGE_MENU%26OASF%3DICX_CAT_PUNCHOUT_CALLBACK%26transactionid%3D270939554%26operationkey%3D94be6a2633d2b5be

// https://microstore-oracle.nendi.fr/oracle/catalog/5902fb7704c176790a7124b2?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImNhcGdlbWluaSIsImlzT3JhY2xlIjp0cnVlLCJob29rX3VybCI6Imh0dHBzOi8vZmllYnNiYXMuY29ycC5jYXBnZW1pbmkuY29tOjQ0NDcvT0FfSFRNTC9PQS5qc3A_T0FGdW5jPUlDWF9DQVRfUFVOQ0hPVVRfQ0FMTEJBQ0smT0FIUD1JQ1hfUE9SX0hPTUVQQUdFX01FTlUmT0FTRj1JQ1hfQ0FUX1BVTkNIT1VUX0NBTExCQUNLJnRyYW5zYWN0aW9uaWQ9MjcwOTM5NTU0Jm9wZXJhdGlvbmtleT05NGJlNmEyNjMzZDJiNWJlIiwiaWF0IjoxNjEwNTUxMzE0fQ.AbSKfQaS1iPnKcuEPZ2tg5W8AyQRJkh-gcaVCb3lntQ&buyerCookie=37151610375253935&HOOK_URL=https%3A%2F%2Ffiebsbas.corp.capgemini.com%3A4447%2FOA_HTML%2FOA.jsp%3FOAFunc%3DICX_CAT_PUNCHOUT_CALLBACK%26OAHP%3DICX_POR_HOMEPAGE_MENU%26OASF%3DICX_CAT_PUNCHOUT_CALLBACK%26transactionid%3D270939554%26operationkey%3D94be6a2633d2b5be



// WEBPACK FOOTER //
// ./src/app/components/cart/cart.component.ts